<div class="header d-flex justify-content-between">
  <h3 class="my-projects">{{variables.myProjects}}</h3>
  <div style="display: flex;">
    <app-button typeBtn="secondary" (click)="alphabeticalOrder()" width="76px" textColor="#FFF"
      [color]="'var(--contrast-color)'" iconPosition="left" icon="sort_by_alpha" iconSize="20px"
      message=""></app-button>
    <!--@if (authService.isAdmin() | async) {-->
    <app-button *hasPermission="Permission.PROJECT_MANAGE" typeBtn="primary" style="margin-left: 10px;"
      message="{{variables.addProject}}" [textColor]="colorWhite" [color]="'var(--primary-color)'"
      (click)="addProject()"></app-button>
    <!--}-->
  </div>
</div>

<mat-form-field class="estimate-search-field" appearance="outline">
  <input matInput placeholder="{{variables.search}}..." search [value]="displayFilterText" (keyup)="searchFilter($event)" />
</mat-form-field>

<div class="content">


  @if (isLoading && !errorDetected) {
  <app-loader class="centerLoader"></app-loader>
  }

  @if (errorDetected) {
  <app-error-message [errorMsg]="errorText"></app-error-message>
  }

  @if (projects.length > 0 && !isLoading && !errorDetected) {
  <div fxLayout="row wrap" fxLayoutGap="32px grid">
    @for (project of projects; track project) {
    <div fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="33%">
      <mat-card [ngClass]="{'inactive': !project.isActive}" class="mat-elevation-z0 project-card">
        <mat-card-header>
          <mat-card-title>{{project.name}}
            @if (!project.active) {
            <span class="icon warning-icon">
              <mat-icon svgIcon="DangerDark" style="width:20px; height:20px;"></mat-icon>
            </span>
            }
          </mat-card-title>
          <mat-card-subtitle>{{project.wbscode}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions>
          <app-button *hasPermission="Permission.PROJECT_READ" typeBtn="primary" message="{{variables.seeMore}}"
            (click)="goToProject(project.id)"></app-button>
          <div class="action_buttons">
            <!--@if (  ((authService.isAdministrator() | async) && project.owner) || (authService.isSuperAdmin() | async) ) {-->
            <span *hasPermission="Permission.PROJECT_MANAGE"
              [showWhen]="project.owner && permissionService.hasPermission(Permission.PROJECT_MANAGE)"
              (click)="editProject(project)" class="icon-edit me-3 action_buttons-item">
              <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
            </span>
            <span *hasPermission="Permission.PROJECT_MANAGE"
              [showWhen]="project.owner && permissionService.hasPermission(Permission.PROJECT_MANAGE)"
              (click)="deleteProject(project)" class="icon-edit action_buttons-item">
              <img src="../../../../assets/svg/BinWhite.svg" alt="Delete Icon" width="20px">
            </span>
            <!--}-->
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
    }
  </div>
  }
</div>